import { gql } from "@apollo/client";
import { createQuery } from "@mostrans/web-components/helpers/graphqlHelpers";

const GET_OPPORTUNITY_IS_ACTIVE = gql`
  query GetActiveOpportunities($userId: Int) {
    getActiveOpportunities(user_id: $userId) {
      data {
        id
        title
        description
        location_id
        CandidateCount
        division_id
        job_level
        is_open
        created_date
        created_by
        updated_date
        updated_by
        deleted_date
        deleted_by
        Location {
          id
          nama
        }
        Division {
          id
          division
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getActiveOpportunities = createQuery({
    query: GET_OPPORTUNITY_IS_ACTIVE,
    defaultValue: null,
    initialVariables: { userId: null },
    selector: "getActiveOpportunities.data",
    responseSelector: "getActiveOpportunities.response"
})

const GET_OPPORTUNITY_BY_ID = gql`
query GetOpportunityByID($getOpportunityByIdId: Int!) {
  getOpportunityByID(id: $getOpportunityByIdId) {
    data {
      Division {
        id
        division
      }
      Location {
        id
        nama
      }
      Requirement {
        id
        opportunity_id
        job_requirement
        created_date
        updated_date
        deleted_date
      }
      created_by
      created_date
      deleted_by
      deleted_date
      description
      division_id
      id
      is_open
      job_level
      location_id
      title
      updated_by
      updated_date
    }
    response {
      status
      errMsg
      id_affected
    }
  }
}`

export const getOpportunityByID = createQuery({
  query: GET_OPPORTUNITY_BY_ID,
  defaultValue: null,
  initialVariables: { getOpportunityByIdId: null },
  selector: "getOpportunityByID.data",
  responseSelector: "getOpportunityByID.response"
})